import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const resources = {
  en: {
    translation: {
      "New pattern": "New pattern",
      Patterns: "Patterns",
      "New name": "New name",
      Save: "save",
      "Background image url": "Background image url",
      "Background image": "Background image",
      Scale: "Scale",
      Guides: "Guides",
      gcode: "gcode",
      Generate: "Generate",
      //toolbox
      Move: "Move",
      "Vertical guide": "Vertical guide",
      "Horizontal guide": "Horizontal guide",
      "Add vertex": "Add vertex",
      "Convert to curve": "convert to curve",
      Mirror: "Mirror",
      Undo: "Undo",
      Redo: "Redo",

      //pdf
      "pdf print instrucctions": `Start print this page without any scaling or margins.
Measure one of the squares to make sure the scaling is correct.`,
    },
  },
  es: {
    translation: {
      //Default values
      "Pattern Name": "Nombre de patrón",
      section: "sección",
      " copy": " copia",
      "Duplicate section": "Duplicar sección",

      //categories
      Language: "Lenguaje",
      Project: "Proyecto",
      Background: "Fondo",
      Parameters: "Parametros",
      Guides: "Guías",
      Export: "Exportar",

      "New pattern": "Nuevo patrón",
      Patterns: "Patrones",
      "New name": "Nuevo nombre",
      Sections: "Secciones",
      "Add section": "Agregar sección",
      "Remove section": "Borrar sección",
      "Section name": "Nombre de sección",
      "Save project": "Guardar proyecto",
      "Background image url": "url para imagen de fondo",
      "Background image": "Imagen de fondo",
      "Invert background colors": "Invertir colores de fondo",
      Brightness: "Brillo",
      Scale: "Escala",
      "Set scale": "Calcular escala",
      Print: "Imprimir",
      gcode: "gcode",
      Generate: "Generar",
      //toolbox
      Move: "Mover",
      "Vertical guide": "Guía vertical",
      "Horizontal guide": "Guía horizontal",
      "Add vertex": "Agregar vértice",
      "Convert to curve": "Convertir a curva",
      Mirror: "Reflejar",
      Undo: "Deshacer",
      Redo: "Rehacer",

      //svg
      "change to curve": "cambiar a curva",
      "delete vexter": "borrar vértice",
      "delete guide": "borrar guia",

      //pdf
      "pdf print instrucctions": `Empieza por imprimir esta página sin escala ni márgenes..
Mide uno de los cuadros para asegurarte que la escala es correcta.`,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    interpolation: {
      escapeValue: false, // react already escapes
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
    },
  });

export default i18n;
